import { render } from "./SellersPage.vue?vue&type=template&id=0465cc78&scoped=true"
import script from "./SellersPage.vue?vue&type=script&lang=js"
export * from "./SellersPage.vue?vue&type=script&lang=js"

import "./SellersPage.vue?vue&type=style&index=0&id=0465cc78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0465cc78"]])

export default __exports__